import { Box, Paper, useMediaQuery, useTheme } from '@mui/material';
import DefaultLayout from 'layouts/DefaultLayout';
import React from 'react';
import ErrorContent from 'pages/Error/ErrorContent';

const ErrorPage = () => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <DefaultLayout>
      {isXs &&
        <>
          <ErrorContent/>
        </>
      }
      {!isXs &&
        <Box margin={'10% auto'} padding={'1rem'}>
          <Paper elevation={4}>
            <ErrorContent/>
          </Paper>
        </Box>

      }

    </DefaultLayout>
  );
};

export default ErrorPage;